import React from 'react';
import { Routes, Route, Navigate, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { T, initials, avatarColor } from './theme';
import Overview from './pages/Overview';
import Brands from './pages/Brands';
import BrandDetail from './pages/BrandDetail';

export default function PmApp() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: T.bg }}>
      {/* Sidebar */}
      <aside style={{ width: 240, background: T.panel, borderRight: `1px solid ${T.border}`, display: 'flex', flexDirection: 'column', padding: '20px 14px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 8px 20px' }}>
          <div style={{ width: 36, height: 36, borderRadius: 9, background: T.blueDark, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800 }}>BR</div>
          <div>
            <div style={{ color: T.text, fontWeight: 700, fontSize: 15 }}>BoldRanks</div>
            <div style={{ color: T.muted, fontSize: 11 }}>Task Yönetim</div>
          </div>
        </div>
        <NavItem to="/overview" icon="📊" label="Overview" />
        <NavItem to="/brands" icon="🏷️" label="Markalar" />
        <div style={{ flex: 1 }} />
        <a href="https://crm.boldranksoperations.space" style={{ ...linkBase, color: T.dim, fontSize: 12 }}>↗ CRM'e git</a>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 8px 4px', borderTop: `1px solid ${T.border}` }}>
          <span style={{ width: 30, height: 30, borderRadius: '50%', background: avatarColor(user?.name), color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700 }}>{initials(user?.name)}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ color: T.text, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.name}</div>
            <div style={{ color: T.dim, fontSize: 11 }}>{user?.role}</div>
          </div>
          <button onClick={() => { logout(); nav('/login'); }} title="Çıkış" style={{ background: 'none', border: 'none', color: T.muted, cursor: 'pointer', fontSize: 16 }}>⏻</button>
        </div>
      </aside>

      {/* İçerik */}
      <main style={{ flex: 1, padding: '28px 32px', overflowY: 'auto', maxHeight: '100vh' }}>
        <Routes>
          <Route path="overview" element={<Overview />} />
          <Route path="brands" element={<Brands />} />
          <Route path="brands/:accountId" element={<BrandDetail />} />
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Routes>
      </main>
    </div>
  );
}

const linkBase = { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, textDecoration: 'none', marginBottom: 4 };
function NavItem({ to, icon, label }) {
  return (
    <NavLink to={to} style={({ isActive }) => ({
      ...linkBase,
      background: isActive ? T.blueDark : 'transparent',
      color: isActive ? '#fff' : T.text2, fontWeight: isActive ? 600 : 500, fontSize: 14,
    })}>
      <span>{icon}</span>{label}
    </NavLink>
  );
}
